import React from 'react';
import { AlertTriangle, PhoneCall, ShieldCheck } from 'lucide-react';
import { ENQUIRY_NUMBER, DISCLAIMER_HI, DISCLAIMER_EN, DATA_LAST_VERIFIED } from '../config/busConfig';

const BusDisclaimer = ({ className = '' }) => {
  const phoneTel = ENQUIRY_NUMBER.split('/')[0].trim().replace(/\D/g, '');

  return (
    <div className={`rounded-xl border border-amber-200 bg-amber-50/70 p-4 sm:p-5 text-amber-950 shadow-sm dark:border-amber-900/50 dark:bg-amber-950/20 dark:text-amber-200 ${className}`}>
      <div className="flex items-start gap-3 sm:gap-4">
        <div className="rounded-lg bg-amber-100 p-2 text-amber-800 dark:bg-amber-900/60 dark:text-amber-300 shrink-0 mt-0.5">
          <AlertTriangle className="h-5 w-5" />
        </div>
        <div className="flex-1 space-y-2 text-sm leading-relaxed">
          <div className="flex flex-wrap items-center justify-between gap-2">
            <span className="font-semibold text-amber-900 dark:text-amber-200 flex items-center gap-1.5">
              <ShieldCheck className="h-4 w-4 text-amber-700 dark:text-amber-400" />
              महत्वपूर्ण सूचना / Official Disclaimer
            </span>
            <span className="text-xs text-amber-800/80 dark:text-amber-400 font-medium bg-amber-100/70 dark:bg-amber-900/40 px-2 py-0.5 rounded">
              Verified: {DATA_LAST_VERIFIED}
            </span>
          </div>

          <p className="text-xs sm:text-sm font-medium text-amber-950 dark:text-amber-100">
            {DISCLAIMER_HI}
          </p>

          <p className="text-xs text-amber-900/90 dark:text-amber-300">
            {DISCLAIMER_EN}
          </p>

          <div className="pt-1 flex flex-wrap items-center gap-3">
            <a
              href={`tel:${phoneTel}`}
              className="inline-flex items-center gap-1.5 rounded-lg bg-amber-700 hover:bg-amber-800 px-3 py-1.5 text-xs font-semibold text-white transition-colors shadow-sm dark:bg-amber-600 dark:hover:bg-amber-500"
            >
              <PhoneCall className="h-3.5 w-3.5" />
              Enquiry: {ENQUIRY_NUMBER}
            </a>
            <span className="text-xs text-amber-800/80 dark:text-amber-400">
              हरियाणा रोडवेज फतेहाबाद बस स्टैंड पूछताछ
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusDisclaimer;
